import React from 'react';
import '../../assets/css/loading/loading.css';

const PageLoading = ({ className = '' }) => {
  return (
    <div className={`page-loading-container ${className}`}>
      <div className="page-loading-content">
        <div className="spinner"></div>
        <p>Loading page content...</p>
      </div>
    </div>
  );
};

export default PageLoading;
